module.exports = __webpack_public_path__ + "img/arrow-up-icon.1d643b1e.svg";